<template>
  <div id="app">
    <div
      v-if="user"
      class="wrapper">
      <Header v-if="user"/>
      <Sidebar v-if="user"/>
      <router-view/>
    </div>
    <div
      v-if="!user">
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/organisms/OrHeader'
import Sidebar from '@/components/organisms/OrSidebar'
import Footer from '@/components/organisms/OrFooter'

export default {
  name: 'App',
  components: {
    Header,
    Sidebar,
    Footer
  },
  computed: {
    user () {
      if (this.$store.state.Auth.user) return true
      return false
    }
  },
  beforeCreate () {
    window.toasted = this.$toasted
  }
}
</script>

<style>
.custom-checkbox label:not(.form-check-label):not(.custom-file-label) {
  font-weight: normal !important;
  padding-left: 1.5rem;
}

.modal-xl {
  max-width: 1140px !important;
}

.modal-fullscreen .modal-dialog {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0 !important;
}

.modal-fullscreen .modal-content {
  min-height: 100vh !important;
}
span.badge {
  line-height: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue